import { useEffect } from "react";

import { View, Alert, Platform } from "react-native";
import { Card, Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import { TextInputHelperText } from "../../../components";
import { FormikFormSwitch } from "../components/FormSwitch";
import ManageVariantsInventory from "../components/ManageVariantsInventory";
import { FormikNumberInput } from "../components/NumberInput";
import useProductFormFormik from "../hooks/useProductFormFormik";
import { confirmAlert } from "../utils";

export default function InventoryScreen() {
  const {
    values: { inventory, variants },
    setFieldValue,
  } = useProductFormFormik();

  const tailwind = useTailwind();

  const showAlert = () => {
    confirmAlert({
      title: "Activar inventario simple",
      body: "Se desactivarán las variantes y el inventario por variantes de tu producto.",
      cancelButton: {
        text: "Regresar",
        onPress: () => setFieldValue("inventory.enabled", false),
      },
      confirmButton: {
        text: "Activar",
        onPress: () => setFieldValue("variants.enabled", false),
      },
    });
  };

  useEffect(() => {
    if (variants.enabled && inventory.enabled) {
      showAlert();
    }
  }, [inventory.enabled]);

  const title = `${
    inventory.enabled && !variants.enabled ? "Desactivar" : "Activar"
  } inventario simple`;

  const body = `Pulsa aquí para ${
    inventory.enabled && !variants.enabled ? "desactivar" : "activar"
  } el inventario simple de tu producto.`;

  const hasVariants = variants.enabled && !!variants.variantsWithOptions.length;

  return (
    <Card style={tailwind("m-3 rounded-xl")}>
      <Card.Content>
        <FormikFormSwitch
          fieldName="inventory.enabled"
          title={title}
          body={body}
        />

        {inventory.enabled && (
          <View style={tailwind("mt-8")}>
            <Text variant="titleMedium">Inventario disponible</Text>

            <FormikNumberInput fieldName="inventory.quantity" />
            <TextInputHelperText info="Ingresa el inventario disponible" />
          </View>
        )}

        {!inventory.enabled && hasVariants && (
          <View style={tailwind("mt-8")}>
            <ManageVariantsInventory />
          </View>
        )}
      </Card.Content>
    </Card>
  );
}
